import type { SavedSeries, SavedSeriesInput, SavedSeriesSectionKey } from '@/types';

import { apiClient } from '../http';

export interface SavedSeriesListParams {
    sectionKey?: SavedSeriesSectionKey;
}

export const savedSeriesService = {
    create: (input: SavedSeriesInput) => apiClient.post<SavedSeries, SavedSeriesInput>('/api/saved-series', input),
    delete: (id: string) => apiClient.delete<{ id: string }>(`/api/saved-series/${id}`),
    list: (params: SavedSeriesListParams, signal?: AbortSignal) =>
        apiClient.get<SavedSeries[], SavedSeriesListParams>('/api/saved-series', { params, signal }),
    update: (id: string, updates: Partial<SavedSeriesInput>) =>
        apiClient.put<SavedSeries, Partial<SavedSeriesInput>>(`/api/saved-series/${id}`, updates),
};
